
export const PageInfoHeader = ({ page = 1, limit = 10, total = 0, label = "list" }) => {
  if (total === 0) {
    return <p className="page-sub-head">No {label} found</p>;
  }

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  return (
    <p className="page-sub-head">
      Showing {start} to {end} of {total} {label}
    </p>
  );
};

